import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

export const useReportSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const type = searchParams.get("type")
  const range = searchParams.get("range")
  const startDate = searchParams.get("startDate")
  const endDate = searchParams.get("endDate")

  const setReportSearchParams = useCallback((filters: Record<string, string>) => {
    setSearchParams((params) => {
      Object.entries(filters).forEach(([key, value]) => {
        if (value && value !== "") {
          params.set(key, value)
        } else {
          params.delete(key)
        }
      })
      return params
    })
  }, [])

  return { type, range, startDate, endDate, setReportSearchParams }
}
